import { Box } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { Header } from '@/components/Header';

type MainLayoutProps = {
  className?: string;
};

export const MainLayout = ({ className }: MainLayoutProps) => {
  return (
    <Box
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        backgroundColor: 'var(--mantine-color-primary-0)',
      }}
    >
      <Box component="header" style={{ position: 'sticky', top: 0, zIndex: 100, flexShrink: 0 }}>
        <Header />
      </Box>
      <Box component="main" style={{ flex: 1, minHeight: 0, backgroundColor: 'var(--mantine-color-primary-0)' }}>
        <Outlet />
      </Box>
    </Box>
  );
};
